/**
 * NEWT FORM Consumer API For Consumer UI
 * NEWT FORM コンシューマ UI からコールされる コンシューマ API です。   
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FormPageAuthenticationInputItemDetail } from './formPageAuthenticationInputItemDetail';


export interface FormPageAuthenticationInputItemAllOf { 
    type: FormPageAuthenticationInputItemAllOf.TypeEnum;
    /**
     * 認証項目（更新キー）であるか
     */
    isUpdateKey: boolean;
    /**
     * 年月日型/月日型の場合に入る
     */
    format?: FormPageAuthenticationInputItemAllOf.FormatEnum;
    detail: FormPageAuthenticationInputItemDetail;
}
export namespace FormPageAuthenticationInputItemAllOf {
    export type TypeEnum = 'string';
    export const TypeEnum = {
        String: 'string' as TypeEnum
    };
    export type FormatEnum = 'date';
    export const FormatEnum = {
        Date: 'date' as FormatEnum
    };
}



